{
  "onboarding": {
    "skip": "ПРОПУСТИТЬ",
    "next": "ДАЛЕЕ →",
    "start": "❤️ НАЧАТЬ",
    "welcome": {
      "title": "Добро пожаловать\nв Agápe Fund",
      "subtitle": "Продвигай платформу, получай сердечки Agápe и поддерживай любимых мастеров реальными пожертвованиями."
    },
    "earn": {
      "title": "Как зарабатывать\nсердечки",
      "subtitle": "Рассказывай о нас — каждый репост, приглашение и комментарий приносит сердечки:",
      "share": "Поделиться контентом",
      "invite": "Пригласить друга",
      "subscribe": "Друг подписался",
      "comment": "Оставить комментарий",
      "review": "Оставить отзыв"
    },
    "convert": {
      "title": "Превращаем\nв пожертвования",
      "subtitle": "Твои сердечки становятся реальными деньгами для мастеров.",
      "hearts100": "100 сердечек",
      "source": "Источник фонда",
      "sourceVal": "10% подписок",
      "minDonation": "Мин. пожертвование",
      "maxMonth": "Макс. в месяц"
    },
    "circle": {
      "title": "Создай свой\nКруг",
      "subtitle": "Чтобы создать собственный круг сообщества, тебе нужно:",
      "subscription": "Активная подписка",
      "subscriptionVal": "Обязательно",
      "hearts": "Минимум сердечек",
      "approvals": "Одобрения друзей",
      "approvalsVal": "10 друзей"
    }
  }
}
